<script lang="ts" context="module">
	import type { ClientUser } from "../../../models/ClientTypes";
	import { getClassicWebUrl } from "../currentUser";
	import ToolbarMenuItem from "./ToolbarMenuItem.svelte";
</script>

<script lang="ts">
	const CLASSIC_WEB_URL = getClassicWebUrl();

	export let user: ClientUser;

	const newslettersUrl = user.caps.feature__new_app_newsletters
		? "/newsletters?s=toolbar-mobile-menu"
		: `${CLASSIC_WEB_URL}/app/my/newsletters?s=toolbar-mobile-menu`;
	const mailingListsUrl = user.caps.feature__new_app_mailing_lists
		? "/lists?s=toolbar-mobile-menu"
		: `${CLASSIC_WEB_URL}/app/lists/manage?s=toolbar-mobile-menu`;
	const accountUrl = user.caps.feature__new_app_account
		? "/account?s=toolbar-mobile-menu"
		: `${CLASSIC_WEB_URL}/app/users/account?s=toolbar-mobile-menu`;
	const teamUrl = user.caps.feature__new_app_management_dashboard
		? `/organization/${user.organization?.screenName}?s=toolbar-mobile-menu`
		: `${CLASSIC_WEB_URL}/app/organization/${user.organization?.screenName}?s=toolbar-mobile-menu`;
</script>

<ToolbarMenuItem title="" url="/account?s=toolbar-mobile-menu" on:click>
	<div class="flex items-start justify-start p-2 leading-tight">
		<img class="size-12 rounded-full" src={user.picture} alt="{user.firstName}'s picture" />
		<div class="m-0 ml-2.5 flex flex-col items-start p-0 text-white">
			<h2 class="text-16 font-bold text-orange-100">{user.name}</h2>
			<div class="mt-[5px] flex flex-col tracking-tight">
				{#if user.organization}
					<h3 class="text-15 font-medium">
						{user.organization.name}
					</h3>
				{/if}
				<span class="text-13 font-normal opacity-70">
					{#if user.organization}
						Smore for Teams
					{:else}
						{user.plan}
					{/if}
				</span>
			</div>
		</div>
	</div>
</ToolbarMenuItem>

<hr class="border-top mt-1 border-white opacity-15" />
{#if user.isOrgAdmin}
	<ToolbarMenuItem title="Team" subtitle="Manage {user.organization?.name} Team" url={teamUrl} on:click />
{/if}
<ToolbarMenuItem title="Newsletters" url={newslettersUrl} on:click />
<ToolbarMenuItem title="Mailing lists" url={mailingListsUrl} on:click />
<ToolbarMenuItem title="Account & billing" url={accountUrl} on:click />
<hr class="border-top mt-1 border-white opacity-15" />
<ToolbarMenuItem title="Logout" url="{CLASSIC_WEB_URL}/app/users/logout" style="warning" on:click />
